'use strict';
module.exports = require('./OverlayPanel.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/overlaypanel/index.js
// module id = 773
// module chunks = 7